// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__126Gd","author":"Table_author__vO22i","authorImage":"Table_authorImage__28i24","unreadRow":"Table_unreadRow__1wZTp"};